export const adaptMyRoleResponse = (response) => {
  return {
    loggedInUserRole: response?.loggedInUserRole || '-',
  };
};
